define('views/blocks/MiniProductInfoView',['underscore', 'jquery', 'backbone', 'SubView', 'app',
        'template!blocks/product/mini-product-info'
    ],
    function (_,$, Backbone,SubView,app,
              template){
        return Backbone.View.extend({
            className:'mini-product-info',
            events:{
              'click .btn-close':'close',
              'click .update-quantity':'changeQuantity',
              'click .submit':'submit',
              'click': 'click',
            },
            initialize:function(options){
                var view = this;
                options.product = app.getProduct(options.id_product);
                _(view).defaults(options);
                this.render();
            },
            render:function(){
                var view = this;
                view.$el.html(template(view))
            },
            click:function(e){
                if($(e.target).is('.mini-product-info')){
                    this.close();
                }
            },
            changeQuantity:function(e){
                var view = this,
                    add = view.$(e.currentTarget).is('.more'),
                    max = view.max,
                    min = view.min,
                    quantity = view.quantity;
                view.quantity = quantity = Math.max(min,Math.min(max,quantity+(add?1:-1)));
                view.$('.less').attr('disabled',min>=quantity);
                view.$('.more').attr('disabled',max<=quantity);
                view.$('.quantity').text(quantity);
            },
            submit:function(){
                var view = this;
                view.trigger('submit',view.quantity);
                view.close();
            },
            close:function(){
                this.trigger('close',this);
            },
        }).extend(SubView);
    });


